function Header() {
    return (
        <header style={{
            backgroundColor: "#b3e5fc",
            padding: "20px",
            margin: "0px",
            textAlign: "center",
            fontSize: "14px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"
        }}>
            <h1>React Beginner Syntax Assignment!</h1>
        </header>
    );
}   
export default Header;